import { LabelTypography } from '../../../../../ui/components/LabelTypography';
import { showGroupsDialog } from '../../../../../ui/features/groups';
import { GroupManagement } from '../../../../../ui/features/groups/components/GroupsManagement';
import { OrganizationsSelection } from '../../../../../ui/features/organizations/components/OrganizationsPanel/components/OrganizationsSelection';
import { OrganizationsSelectionAnonymous } from '../../../../../ui/features/organizations/components/OrganizationsPanel/components/OrganizationsSelectionAnonymous';
import { showOrganizationTreeDialog } from '../../../../../ui/features/organizations/components/OrganizationsTreeDialog';
import { showOrganizationTreeDialogAnonymous } from '../../../../../ui/features/organizations/components/OrganizationsTreeDialog/OrganizationsTreeDialogAnonymous';
import { toKebabCase } from '../../../../../utils';
import { buildGeneralTab, buildHiddenTab, buildStyleTab, buildValidateTab, showWidgetEditDialog, } from '@juvare/common-form-ui/WidgetEditDialog';
import { FormHelperErrorDescription } from '@juvare/common-form-ui/WidgetForm/Components';
import { defaultWidgetLabelProvider, getLabelAndValuePairs, getVisibleError, handleWidgetUpdate, joinLabels, makeNewConfigUnique, renderForm, validateCustom, } from '@juvare/common-form-ui/WidgetForm/Utils';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import CheckIcon from '@mui/icons-material/Check';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import { Box, Button, Divider, FormControl, FormLabel, Typography } from '@mui/material';
import React from 'react';
const type = 'contactManagement.accessSharing';
export const WidgetAccessSharing = (props) => {
    var _a, _b, _c, _d;
    const getValue = () => props.getData();
    const value = getValue();
    const error = getVisibleError(props);
    const setValue = (newValue) => {
        props.setData(newValue);
        renderForm(props, { changed: true });
    };
    const showSelectAllChildren = props.config.showSelectAllChildren;
    const showDivider = isOrganizations(value) || isGroups(value);
    const showGroupManagement = isGroups(value);
    const showOrganizationManagement = isOrganizations(value) || !((_a = props.config.sharingOptions) === null || _a === void 0 ? void 0 : _a.length);
    const selectedOrganizationIds = isOrganizations(value) ? value.organizations : [];
    const selectedGroupIds = isGroups(value) ? value.groups : [];
    const setOrganizationsValue = (ids = []) => setValue({ type: 'organizations', organizations: ids });
    const setGroupsValue = (ids = []) => setValue({ type: 'groups', groups: ids });
    const setFlagValue = (key) => setValue({ type: key });
    const handleOrganizationChange = (organizationIds) => {
        setValue({ type: 'organizations', organizations: organizationIds });
    };
    const handleAddGroup = () => {
        showGroupsDialog({
            enableRowSelection: true,
            selectedGroupIds: selectedGroupIds,
            excludeFilterBasedGroups: true,
            onSelect: (selectedIds) => {
                if (!Array.isArray(selectedIds)) {
                    return;
                }
                setGroupsValue(selectedIds);
            },
        });
    };
    const handleRemoveGroup = (groupId) => {
        if (!isGroups(value)) {
            return;
        }
        const groupIds = value.groups.filter((id) => id !== groupId);
        setGroupsValue(groupIds);
    };
    return (React.createElement(FormControl, { error: !!error, disabled: props.config.disabled, fullWidth: true },
        props.config.label && (React.createElement(FormLabel, { sx: { marginBottom: 0.5 }, error: !!error }, props.config.label)),
        React.createElement(Box, { sx: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                p: 2,
            } },
            React.createElement(Typography, { variant: 'h6' }, props.config.subtitle),
            props.config.sharingOptions && props.config.sharingOptions.length > 0 && (React.createElement(Box, { sx: {
                    display: 'flex',
                    alignItems: 'stretch',
                    padding: '0 1px 0 1px',
                    gap: props.config.hideOptionButtonsDivider ? 2 : 0,
                } }, (_b = props.config.sharingOptions) === null || _b === void 0 ? void 0 : _b.map((option, index) => (React.createElement(React.Fragment, { key: option.type },
                !props.config.hideOptionButtonsDivider && index > 0 && React.createElement(DividerWithLabel, { label: 'or' }),
                React.createElement(BigToggleButton, { icon: option.icon, label: option.label, selected: isSelected(value, option.type), onClick: () => {
                        var _a;
                        if (option.type) {
                            if (option.type === 'organizations') {
                                setOrganizationsValue([]);
                                if (props.config.anonymous) {
                                    showOrganizationTreeDialogAnonymous({
                                        showSelectAllChildren,
                                        initialSelectedOrganizationIds: selectedOrganizationIds,
                                        multiSelect: true,
                                        onChange: handleOrganizationChange,
                                    });
                                }
                                else {
                                    showOrganizationTreeDialog({
                                        showSelectAllChildren,
                                        staticFilters: {
                                            visible: (_a = props.config.includeVisible) !== null && _a !== void 0 ? _a : undefined,
                                            permission: props.config.includeByMembership ? 'member' : undefined,
                                            orgPermissions: props.config.includeByOrgPermission,
                                        },
                                        initialSelectedOrganizationIds: selectedOrganizationIds,
                                        multiSelect: true,
                                        onChange: handleOrganizationChange,
                                    });
                                }
                            }
                            else if (option.type === 'groups') {
                                setGroupsValue([]);
                            }
                            else {
                                setFlagValue(option.type);
                            }
                        }
                        else {
                            setValue(undefined);
                        }
                    } })))))),
            showDivider && React.createElement(Divider, { sx: { color: themeColors.border.main } }),
            showOrganizationManagement && (React.createElement(Box, null, props.config.anonymous ? (React.createElement(OrganizationsSelectionAnonymous, { showSelectAllChildren: showSelectAllChildren, organizationIds: selectedOrganizationIds, renderOrganization: (organization) => (React.createElement(LabelTypography, { sx: { flexGrow: 1 }, color: organization.disabled ? 'textSecondary' : 'initial', "aria-disabled": organization.disabled }, organization.name)), hideValidationMessage: true, onChangeOrganizationIds: handleOrganizationChange, addLabel: props.config.addLabel })) : (React.createElement(OrganizationsSelection, { showSelectAllChildren: showSelectAllChildren, organizationIds: selectedOrganizationIds, staticDialogFilters: {
                    visible: (_c = props.config.includeVisible) !== null && _c !== void 0 ? _c : false,
                    permission: props.config.includeByMembership ? 'member' : undefined,
                    orgPermissions: props.config.includeByOrgPermission,
                }, renderOrganization: (organization) => (React.createElement(LabelTypography, { sx: { flexGrow: 1 }, color: organization.disabled ? 'textSecondary' : 'initial', "aria-disabled": organization.disabled }, organization.name)), hideValidationMessage: true, onChangeOrganizationIds: handleOrganizationChange, addLabel: props.config.addLabel })))),
            showGroupManagement && (React.createElement(GroupManagement, { groupIds: selectedGroupIds, onAddGroup: handleAddGroup, onRemoveGroup: handleRemoveGroup })),
            error && React.createElement(FormHelperErrorDescription, { error: error }),
            ((_d = props.config.sharingOptions) !== null && _d !== void 0 ? _d : [])
                .filter((option) => isSelected(value, option.type) && option.description)
                .map((option) => (React.createElement(Typography, { key: option.type, variant: 'body2', sx: { color: themeColors.text.subtle } }, option.description))))));
};
export const WidgetAccessSharingEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, {
            title: 'Access Sharing',
        }, buildGeneralTab(props, {
            key: true,
            labelOptional: true,
            disabled: true,
            children: [
                {
                    type: 'form.text',
                    key: 'subtitle',
                    label: 'Subtitle',
                    emptyAsNull: true,
                },
                {
                    type: 'form.checkbox',
                    key: 'includeVisible',
                    label: 'Include Visible',
                    tooltip: { text: 'Organizations with the visible flag set to true' },
                },
                {
                    type: 'form.checkbox',
                    key: 'includeByMembership',
                    label: 'Include By Membership',
                    tooltip: { text: 'Organizations where currently logged in user is a member of' },
                },
                {
                    type: 'form.multiSelect',
                    key: 'includeByOrgPermission',
                    label: 'Include By Org Permission',
                    tooltip: { text: 'Organization where currently logged in user has any of the selected permissions' },
                    valueProvider: { type: 'contactManagement.orgPermission' },
                },
                { type: 'form.checkbox', key: 'disableNotVisible', label: 'Disable Not Visible' },
                { type: 'form.checkbox', key: 'showSelectAllChildren', label: 'Show Select All Children' },
                { type: 'form.checkbox', key: 'hideOptionButtonsDivider', label: 'Hide Option Buttons Divider' },
            ],
            onSubmit: (data) => {
                var _a;
                if (((_a = data.includeByOrgPermission) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                    delete data.includeByOrgPermission;
                }
                return data;
            },
        }), {
            label: 'Sharing Options',
            children: [
                {
                    type: 'form.dataGrid',
                    key: 'sharingOptions',
                    emptyAsNull: true,
                    reorder: true,
                    children: [
                        {
                            type: 'form.panel',
                            children: [
                                {
                                    type: 'form.text',
                                    key: 'type',
                                    label: 'Type',
                                    description: 'Use type "organizations" to show organization picker. Use type "groups" to show group picker. Use empty type for "no sharing" option',
                                    emptyAsNull: true,
                                    validate: {
                                        uniqueInGrid: true,
                                    },
                                },
                            ],
                            style: {
                                width: 300,
                            },
                        },
                        {
                            type: 'form.panel',
                            children: [
                                {
                                    type: 'form.select',
                                    key: 'icon',
                                    label: 'Icon',
                                    values: [
                                        { value: 'material-group-add', label: 'Group Add' },
                                        { value: 'material-groups', label: 'Groups' },
                                        { value: 'material-person', label: 'Person' },
                                        { value: 'material-group-outlined', label: 'Group Outlined' },
                                    ],
                                },
                                {
                                    type: 'form.text',
                                    key: 'label',
                                    label: 'Label',
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    type: 'form.text',
                                    key: 'description',
                                    label: 'Description',
                                    multiline: true,
                                    rows: 3,
                                },
                            ],
                        },
                    ],
                },
            ],
        }, buildValidateTab(props, {
            required: true,
            children: [
                {
                    type: 'form.number',
                    key: 'validate.minOrganizationsLength',
                    label: 'Min Number of Organizations',
                },
                {
                    type: 'form.number',
                    key: 'validate.maxOrganizationsLength',
                    label: 'Max Number of Organizations',
                },
                {
                    type: 'form.number',
                    key: 'validate.minGroupsLength',
                    label: 'Min Number of Groups',
                },
                {
                    type: 'form.number',
                    key: 'validate.maxGroupsLength',
                    label: 'Max Number of Groups',
                },
            ],
        }), buildHiddenTab(props), buildStyleTab(props)) }),
        React.createElement(WidgetAccessSharing, Object.assign({}, props))));
};
export const widgetAccessSharing = {
    type,
    validate: (props) => {
        const value = props.getData();
        const validationConfig = props.config.validate;
        if ((validationConfig === null || validationConfig === void 0 ? void 0 : validationConfig.required) && !value) {
            return 'Option must be selected';
        }
        if (isOrganizations(value)) {
            const len = value.organizations.length;
            if ((validationConfig === null || validationConfig === void 0 ? void 0 : validationConfig.minOrganizationsLength) && len < validationConfig.minOrganizationsLength) {
                return `At least ${validationConfig.minOrganizationsLength} organizations must be selected`;
            }
            if ((validationConfig === null || validationConfig === void 0 ? void 0 : validationConfig.maxOrganizationsLength) && len > validationConfig.maxOrganizationsLength) {
                return `No more than ${validationConfig.maxOrganizationsLength} organizations can be selected`;
            }
        }
        if (isGroups(value)) {
            const len = value.groups.length;
            if ((validationConfig === null || validationConfig === void 0 ? void 0 : validationConfig.minGroupsLength) && len < validationConfig.minGroupsLength) {
                return `At least ${validationConfig.minGroupsLength} groups must be selected`;
            }
            if ((validationConfig === null || validationConfig === void 0 ? void 0 : validationConfig.maxGroupsLength) && len > validationConfig.maxGroupsLength) {
                return `No more than ${validationConfig.maxGroupsLength} groups can be selected`;
            }
        }
        return validateCustom(props, value);
    },
    update: handleWidgetUpdate,
    getLabelValueAsTextPairs: (props, labelPrefix) => {
        var _a, _b, _c;
        const value = props.getData();
        if (!value)
            return [];
        const label = joinLabels(labelPrefix, props.config.label);
        if (isOrganizations(value)) {
            const organizationsLength = value.organizations.length;
            const text = organizationsLength
                ? `${organizationsLength} organization${organizationsLength > 1 ? 's' : ''} selected`
                : 'No organizations selected';
            return getLabelAndValuePairs(label, text);
        }
        if (isGroups(value)) {
            const groupsLength = value.groups.length;
            const text = groupsLength ? `${groupsLength} group${groupsLength > 1 ? 's' : ''} selected` : 'No groups selected';
            return getLabelAndValuePairs(label, text);
        }
        // Simple flag (e.g., "public", etc.)
        const optionLabel = (_c = (_b = (_a = props.config.sharingOptions) === null || _a === void 0 ? void 0 : _a.find((o) => o.type === value.type)) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : value.type;
        return getLabelAndValuePairs(label, optionLabel);
    },
    component: WidgetAccessSharing,
    icon: React.createElement(CheckIcon, { fontSize: 'small' }),
    editorComponent: WidgetAccessSharingEditor,
    createWidget: (rootConfig, editorPath, widgets) => makeNewConfigUnique(rootConfig, editorPath, widgets, { type, key: 'sharing' }),
};
const isOrganizations = (v) => (v === null || v === void 0 ? void 0 : v.type) === 'organizations';
const isGroups = (v) => (v === null || v === void 0 ? void 0 : v.type) === 'groups';
const isFlag = (v) => !!v && v.type !== 'organizations' && v.type !== 'groups';
function isSelected(value, type) {
    if (!type || !value) {
        return false;
    }
    if (type === 'organizations') {
        return isOrganizations(value);
    }
    if (type === 'groups') {
        return isGroups(value);
    }
    return isFlag(value) && value.type === type;
}
const BigToggleButton = ({ icon, label, selected, onClick, }) => (React.createElement(Button, { variant: 'outlined', sx: {
        flex: '1 1 0px',
        flexDirection: 'column',
        p: 2,
        textTransform: 'none',
        outline: selected ? '2.5px solid ' + themeColors.primary.base : 'none',
        outlineOffset: -1,
    }, onClick: onClick, "data-test": `big-toggle-button-${toKebabCase(label)}`, "aria-pressed": selected },
    icon && React.createElement(BigToggleButtonIcon, { icon: icon }),
    React.createElement(Typography, { variant: 'subtitle2', sx: { pt: 2 } }, label)));
const BigToggleButtonIcon = ({ icon }) => (React.createElement(Box, { sx: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: themeColors.accent.blue.subtlest,
        width: 40,
        height: 40,
        borderRadius: 20,
    } },
    icon === 'material-group-add' && React.createElement(GroupAddOutlinedIcon, null),
    icon === 'material-groups' && React.createElement(GroupsOutlinedIcon, null),
    icon === 'material-person' && React.createElement(PersonOutlinedIcon, null),
    icon === 'material-group-outlined' && React.createElement(GroupOutlinedIcon, null)));
const DividerWithLabel = ({ label }) => (React.createElement(Divider, { orientation: 'vertical', flexItem: true },
    React.createElement(Typography, { variant: 'caption', sx: { color: themeColors.border.boldest } }, label)));
